"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationCodeResetPasswordLogin = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _GradientPanel = require("../../atoms/GradientPanel");

var _react = require("react");

var _LogoImage = require("../../atoms/LogoImage");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _GeneralInput = require("../../atoms/GeneralInput");

var _GeneralButton = require("../../atoms/GeneralButton");

var _utils = require("./utils");

var _jsxRuntime = require("react/jsx-runtime");

var VerificationCodeResetPasswordLogin = function VerificationCodeResetPasswordLogin(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      resend = _useState2[0],
      setResend = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      awsError = _useState4[0],
      setAwsError = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      emptyVerificationCode = _useState6[0],
      setEmptyVerificationCode = _useState6[1];

  var _useState7 = (0, _react.useState)(document.querySelectorAll("[id^='verificationCodeInput']")),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      inputCodeVerificationAll = _useState8[0],
      setInputCodeVerificationAll = _useState8[1];

  var inputPositions = [1, 2, 3, 4, 5, 6];
  (0, _react.useEffect)(function () {
    props.confirmationError !== "" && setEmptyVerificationCode(false);
  }, [props.confirmationError]);

  var checkCode = function checkCode(e, flag) {
    var valid = true;
    e.preventDefault();
    var code = "";

    if (awsError === "" && !flag) {
      inputPositions.map(function (position) {
        return code = code + document.querySelector("#verificationCodeInput".concat(position)).value;
      });

      if (sessionStorage.getItem("resetError")) {
        JSON.parse(sessionStorage.getItem("confirmationCode")) === code && (valid = false);
      }

      sessionStorage.setItem("confirmationCode", JSON.stringify(code));
      valid && !sessionStorage.getItem("resetPasswordProcess") && props.setPaso(6);
      valid && sessionStorage.getItem("resetPasswordProcess") && props.setPaso(8);
    }
  };

  var validateResend = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var email;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              email = JSON.parse(sessionStorage.getItem("email"));
              _context.prev = 2;
              _context.next = 5;
              return props.Auth.forgotPassword(email);

            case 5:
              sessionStorage.setItem("email", JSON.stringify(email));
              sessionStorage.setItem("resetPasswordProcess", JSON.stringify("true"));
              props.setPaso(5);
              setEmptyVerificationCode(false);
              setResend(true);
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              setAwsError(_context.t0.code);
              console.log(_context.t0.message);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    return function validateResend(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    setInputCodeVerificationAll(document.querySelectorAll("[id^='verificationCodeInput']"));
  }, []);
  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: "Ingresa tus credenciales"
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "user",
    children: [sessionStorage.getItem("email") && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: "Ingrese el c\xF3digo de verificaci\xF3n enviado a: ".concat(JSON.parse(sessionStorage.getItem("email"))),
      headerType: "input-name-header"
    }), !sessionStorage.getItem("email") && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: "Ingrese c\xF3digo de verificaci\xF3n enviado a: ".concat(JSON.parse(sessionStorage.getItem("nuevoRegistro")).email),
      headerType: "input-name-header"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "verification-code",
      children: inputPositions.map(function (position) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralInput.GeneralInput, {
          inputId: "verificationCodeInput".concat(position),
          inputType: "text",
          inputPlaceholder: "X",
          validateInput: _utils.validateInput,
          inputsArray: inputCodeVerificationAll,
          position: position,
          maxChar: 1
        });
      })
    }), emptyVerificationCode && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese su c\xF3digo de verificaci\xF3n"
    }), sessionStorage.getItem("resetError") && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "C\xF3digo de verifiaci\xF3n incorrecto"
    }), props.confirmationError === "LimitExceededException" && !emptyVerificationCode && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Haz realizado demasiados intentos, intentalo m\xE1s tarde"
    }), props.confirmationError === "CodeMismatchException" && !emptyVerificationCode && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "C\xF3digo de verificaci\xF3n incorrecto"
    }), props.confirmationError === "ExpiredCodeException" && !emptyVerificationCode && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "El c\xF3digo ingresado est\xE1 expirado"
    }), props.confirmationError === "InternalErrorException" && !emptyVerificationCode && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Algo sali\xF3 mal, porfavor vuelva a intentarlo"
    }), awsError === "LimitExceededException" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Haz realizado demasiados intentos, intentalo m\xE1s tarde"
    }), awsError === "InternalErrorException" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Algo sali\xF3 mal, porfavor vuelva a intentarlo"
    }), resend && awsError === "" && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      className: "resendTrue",
      children: "Se reenvi\xF3 el c\xF3digo de verificaci\xF3n correctamente"
    })]
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "resend-code",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      onClick: function onClick(e) {
        return validateResend(e);
      },
      children: "Reenviar c\xF3digo de verificaci\xF3n"
    })
  }, "4"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "button-center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        var flag = (0, _utils.validate)(inputCodeVerificationAll);
        checkCode(e, flag);
        setEmptyVerificationCode(flag);
      }
    })
  }, "5"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "reset-password",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      onClick: function onClick() {
        return props.setPaso(10);
      },
      children: "Regresar..."
    })
  }, "6")];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
      componentsArray: loginRight,
      panelType: "home-login",
      panelColor: _variables.GlobalColors.white
    })
  });
};

exports.VerificationCodeResetPasswordLogin = VerificationCodeResetPasswordLogin;